/**
 * @generated SignedSource<<40ec21518a193243de33070c6ed06141>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreCalendarUpdateInput = {
  color: string;
  teamIds: ReadonlyArray<string>;
  title: string;
};
export type CalendarEditMutation$variables = {
  calendarId: string;
  input: StoreCalendarUpdateInput;
};
export type CalendarEditMutation$data = {
  readonly store: {
    readonly calendar: {
      readonly updateCalendar: {
        readonly color: string;
        readonly iCalUrl: string | null;
        readonly id: string;
        readonly teams: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly title: string;
      };
    };
  };
};
export type CalendarEditMutation = {
  response: CalendarEditMutation$data;
  variables: CalendarEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
          }
        ],
        "concreteType": "StoreCalendarMutation",
        "kind": "LinkedField",
        "name": "calendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "updateCalendar",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iCalUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarEditMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarEditMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c4f7a273e5e39c3409da77e4622b1b63",
    "id": null,
    "metadata": {},
    "name": "CalendarEditMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarEditMutation(\n  $calendarId: ID!\n  $input: StoreCalendarUpdateInput!\n) {\n  store {\n    calendar(calendarId: $calendarId) {\n      updateCalendar(input: $input) {\n        id\n        title\n        color\n        teams {\n          id\n        }\n        iCalUrl\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc8b77fc297228ecea2c3fdc80acab1f";

export default node;
